export type ClientConfig = {
  apiUrl: string;
  facebookPixelId: string;
  googleClientId: string;
  googleAnalyticsId: string;
  isDevelopment: boolean;
  telemetry: {
    datadogClientToken?: string;
    environment: "development" | "production";
  };
  purchases: {
    iosApiKey: string;
    androidApiKey: string;
  };
  limits: {
    defaultApiTimeoutMs: number;
    uploadApiTimeoutMs: number;
    uploadNoProgressTimeoutMs: number;
  };
};

const DEFAULT_API_URL = "https://api.1transcribe.com";
const DEVELOPMENT_API_URL = "https://api-dev.1transcribe.com";

export const loadConfig = (): ClientConfig => {
  const configuredApiUrl = import.meta.env.VITE_SERVER_URL?.trim();
  const apiUrl =
    configuredApiUrl ||
    (import.meta.env.DEV ? DEVELOPMENT_API_URL : DEFAULT_API_URL);

  return {
    apiUrl: apiUrl.replace(/\/$/, ""),
    facebookPixelId:
      import.meta.env.VITE_PUBLIC_FACEBOOK_PIXEL_ID?.trim() ||
      "1229780541390171",
    googleClientId: import.meta.env.VITE_PUBLIC_GOOGLE_CLIENT_ID?.trim() || "",
    googleAnalyticsId:
      import.meta.env.VITE_PUBLIC_GA_ID?.trim() || "G-808N2YC6SB",
    isDevelopment: import.meta.env.DEV,
    telemetry: {
      datadogClientToken:
        import.meta.env.VITE_PUBLIC_DATADOG_CLIENT_TOKEN?.trim() || undefined,
      environment: import.meta.env.DEV ? "development" : "production",
    },
    purchases: {
      iosApiKey: "appl_irSTXHHMlTkheHOLHYYamIHSnJT",
      androidApiKey: "goog_NmeMKcNQFojdpuRrbvTiDrszZQX",
    },
    limits: {
      defaultApiTimeoutMs: 30_000,
      uploadApiTimeoutMs: 120_000,
      uploadNoProgressTimeoutMs: 45_000,
    },
  };
};
